function List({ color }) {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_158_8268)">
        <path
          d="M0.859375 8.44443H21.1406C21.6133 8.44443 22 8.91943 22 9.49998C22 10.0805 21.6133 10.5555 21.1406 10.5555H0.859375C0.386719 10.5555 0 10.0805 0 9.49998C0 8.91943 0.386719 8.44443 0.859375 8.44443Z"
          fill={color}
        />
        <path
          d="M0.859375 0H21.1406C21.6133 0 22 0.475 22 1.05556C22 1.63611 21.6133 2.11111 21.1406 2.11111H0.859375C0.386719 2.11111 0 1.63611 0 1.05556C0 0.475 0.386719 0 0.859375 0Z"
          fill={color}
        />
        <path
          d="M0.859375 16.8889H21.1406C21.6133 16.8889 22 17.3639 22 17.9444C22 18.525 21.6133 19 21.1406 19H0.859375C0.386719 19 0 18.525 0 17.9444C0 17.3639 0.386719 16.8889 0.859375 16.8889Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_158_8268">
          <rect
            width="22"
            height="19"
            fill="white"
            transform="matrix(-1 0 0 1 22 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default List;
